import { useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import useNavigationParams from '../../hooks/useNavigationParams';
import { useViewConfig } from '../../hooks/useViewConfig';
import { WAGERING_NAV_ITEM_COLLECTION } from '../../constants/viewConfig';
import useIsDesktopLayout from '../../hooks/useIsDesktopLayout';
import FEATURES from '../../constants/featureToggling';
import {
  BOUSES_COLLECTING_GAMES_NAV_ITEM,
  BONUSES_NAV_ITEM,
  HALL_OF_FAME_NAV_ITEM,
  ROOT_NAV_ITEM,
  RULES_NAV_ITEM,
  SEARCH_NAV_ITEM,
  SPECIAL_OFFERS_NAV_ITEM,
  TOURNAMENT_NAV_ITEM,
} from '../../constants/navigation';
import { useTournamentLobbyAvailable } from '../../hooks/useTournamentLobbyRedirect';

export const useMainNavigation = () => {
  const isDesktop = useIsDesktopLayout();
  const {
    isLoggedIn,
    hasBonuses,
    hasSpecialOffers,
    hasBonusCollectingGames,
    hasBonusWageringGames,
  } = useNavigationParams();

  const hasHallOfFame = useFeature(FEATURES.ENABLE_HALL_OF_FAME).on;
  const WageringNavItem = useViewConfig(WAGERING_NAV_ITEM_COLLECTION);
  const areRulesEnabled = useFeature(FEATURES.HOW_TO_PLAY).on;
  const isTournamentLobbyAvailable = useTournamentLobbyAvailable();

  return useMemo(
    () =>
      [
        ROOT_NAV_ITEM,
        isDesktop && SEARCH_NAV_ITEM,
        hasBonuses && BONUSES_NAV_ITEM,
        isTournamentLobbyAvailable && TOURNAMENT_NAV_ITEM,
        hasSpecialOffers && SPECIAL_OFFERS_NAV_ITEM,
        isLoggedIn &&
          hasBonuses &&
          hasBonusCollectingGames &&
          BOUSES_COLLECTING_GAMES_NAV_ITEM,
        isLoggedIn && hasBonuses && hasBonusWageringGames && WageringNavItem,
        areRulesEnabled && RULES_NAV_ITEM,
        hasHallOfFame && HALL_OF_FAME_NAV_ITEM,
      ].filter(Boolean),
    [
      isDesktop,
      isLoggedIn,
      hasBonuses,
      areRulesEnabled,
      isTournamentLobbyAvailable,
      hasSpecialOffers,
      hasBonusCollectingGames,
      hasBonusWageringGames,
      hasHallOfFame,
      WageringNavItem,
    ]
  );
};
